import React, { useContext } from "react";
import classnames from "clsx";
import { TabContent, TabPane, NavItem, NavLink } from "reactstrap";
import ProductSizeList from "./productModalSizeList";
import { selectProductSizes, selectProductSizeTypes } from "../../selectors";
import { useAppSelector } from "@/redux/store";
import useActiveSizeTypeSizes from "@/components/product/hooks/useActiveSizeTypeSizes";
import { MobileSizesContext } from "../productMobileSizes";

const ProductModalMultiSize = () => {
  const {
    activeSizeType,
    onSizeTypeSelection,
    selectedSizeFullData: { sizeType: selectedSizeType }
  } = useContext(MobileSizesContext);
  const productSizes = useAppSelector(selectProductSizes);
  const productSizeTypes = useAppSelector(selectProductSizeTypes);
  const activeTypeSizes = useActiveSizeTypeSizes(productSizes, activeSizeType);

  return (
    <div>
      <ul className="multiSizeTabs">
        {productSizeTypes?.map((sizeType: TextAttributeField) => {
          const { key: sizeTypeKey, label } = sizeType;

          return (
            <NavItem key={sizeTypeKey}>
              <NavLink
                className={classnames({
                  active: activeSizeType.key === sizeTypeKey
                })}
                onClick={() => {
                  onSizeTypeSelection(sizeType);
                }}
              >
                {label}
              </NavLink>
            </NavItem>
          );
        })}
      </ul>
      <div className="multiSizeTabsContent">
        <TabContent activeTab={activeSizeType.key}>
          {productSizeTypes?.map((sizeType: TextAttributeField) => (
            <TabPane tabId={sizeType.key} key={sizeType.key}>
              <ProductSizeList
                productSizes={activeTypeSizes}
                isActive={selectedSizeType.key === sizeType.key}
              />
            </TabPane>
          ))}
        </TabContent>
      </div>
    </div>
  );
};

export default ProductModalMultiSize;
